export const getProfileData = state => state.profile.manager;
export const profileIsFetching = state => state.profile.loading;